import { render, staticRenderFns } from "./PatientFilterSelect.vue?vue&type=template&id=2d8107e3&"
import script from "./PatientFilterSelect.vue?vue&type=script&lang=js&"
export * from "./PatientFilterSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports